"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _animationHelper = babelHelpers.interopRequireDefault(require("animation-helper"));

var _compat = require("compat");

var _decorators = require("decorators");

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _temp;

var AnimatedComponent = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(AnimatedComponent, _Component);

  function AnimatedComponent() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, AnimatedComponent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(AnimatedComponent)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "styleName", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "start", _descriptor2, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "end", _descriptor3, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "children", _descriptor4, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "enter", _descriptor5, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "duration", _descriptor6, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "format", _descriptor7, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "boxStyle", _descriptor8, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "finishElementStyle", _descriptor9, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "wrapperType", _descriptor10, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    babelHelpers.initializerDefineProperty(_this, "className", _descriptor11, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(AnimatedComponent, [{
    key: "render",
    value: function render() {
      var Wrapper = this.wrapperType;
      return _react.default.createElement(Wrapper, {
        ref: this.gotElement,
        style: this.boxStyle,
        className: this.className
      }, this.children);
    }
  }, {
    key: "gotElement",
    value: function gotElement(element) {
      this.element = element; // this.init(element);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.enter != this.props.enter || prevProps.boxStyle !== this.props.boxStyle || prevProps.styleName !== this.props.styleName) {
        this.doSwitchState();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._currentAnimation) {
        this._currentAnimation.animation.stop();
      }
    }
  }, {
    key: "doSwitchState",
    value: function doSwitchState() {
      var _this2 = this;

      var start = this.enter ? this.start(this.element) : this.end(this.element);
      var end = this.enter ? this.end(this.element) : this.start(this.element);
      console.log({
        prop: this.styleName,
        start: start,
        end: end
      });

      if (this.currentAnimation) {
        this._currentAnimation.animation.stop();
      }

      var ts = this.styleName.reduce(function (acc, value) {
        return Object.assign(acc, babelHelpers.defineProperty({}, value, _this2.format(start[value], value)));
      }, {});
      Object.assign(this.element.style, ts);
      this._currentAnimation = {
        animation: new _animationHelper.default(this.duration, 'ease-in-out', this.animateStep, this.animateEnd),
        start: start,
        end: end
      };

      this._currentAnimation.animation.start();
    }
  }, {
    key: "animateStep",
    value: function animateStep(percent) {
      var _this3 = this;

      if (!this._currentAnimation) return;
      var _this$_currentAnimati = this._currentAnimation,
          start = _this$_currentAnimati.start,
          end = _this$_currentAnimati.end;
      var tgtValue;
      tgtValue = this.styleName.reduce(function (acc, value) {
        return Object.assign(acc, babelHelpers.defineProperty({}, value, _this3.format(start[value] + (end[value] - start[value]) * percent, value)));
      }, {});
      console.log(start, end, tgtValue);
      Object.assign(this.element.style, tgtValue);
    }
  }, {
    key: "animateEnd",
    value: function animateEnd(finished) {
      if (finished) {
        this.finishElementStyle(this.element, this.enter);
      }

      this._currentAnimation = null;
    }
  }]);
  return AnimatedComponent;
}(_react.Component), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "styleName", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return ['opacity'];
  }
}), _descriptor2 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "start", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (el) {
      return {
        opacity: 0
      };
    };
  }
}), _descriptor3 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "end", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (el) {
      return {
        opacity: 1
      };
    };
  }
}), _descriptor4 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "children", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "enter", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "duration", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return 300;
  }
}), _descriptor7 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "format", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (value) {
      return value;
    };
  }
}), _descriptor8 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "boxStyle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return {};
  }
}), _descriptor9 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "finishElementStyle", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return function (element, state) {};
  }
}), _descriptor10 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "wrapperType", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "div";
  }
}), _descriptor11 = babelHelpers.applyDecoratedDescriptor(_class.prototype, "className", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), babelHelpers.applyDecoratedDescriptor(_class.prototype, "gotElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "gotElement"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "animateStep", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "animateStep"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "animateEnd", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "animateEnd"), _class.prototype)), _class);
exports.default = AnimatedComponent;